export const ARCHIVED_STATUS = 'archived' as const;
